import type { IService } from "../../entities/Service";
import { PALETTE } from "./constants";
import type { Palette } from "./types";

type EngineConfig = {
	palette?: Palette;
};

class EngineConfigService implements IService {
	public readonly serviceName = "⚙️ EngineConfig";

	public readonly palette: Palette;

	constructor({ palette }: EngineConfig = {}) {
		this.palette = palette ?? PALETTE;
	}

	public initialize(): void {}
	public dispose(): void {}
}

export { type EngineConfig, EngineConfigService };
